module.exports = __webpack_public_path__ + "img/hero-temp.7bc5b043.jpg";